import React, {Component} from "react";
import FlexView from "react-flexview";
import SimpleCamera from "../../../../../../modules/SimpleCamera";

class TabFoto extends Component {
    constructor(props) {
        super(props);
        this.fileInputRef = React.createRef();
        this.state = {
            loading: false
        }
    }

    handleChangeFile = (name, value) => {
        this.props.onSetState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                dataPhoto: {
                    ...prevState.data.dataPhoto,
                    [name]: value
                }
            }
        }))
    }

    render() {
        return (
            <>
                <div className="grid grid-2x gap-20px grid-mobile-none">
                    <div id="grid-1">
                        <FlexView column style={{height: "45%"}}>
                            <SimpleCamera
                                id="input_upload_foto_ktp"
                                name="ktpBase64"
                                label="1. Foto KTP"
                                mandatory
                                enableUpload
                                errorMessage={this.props.errors?.["dataPhoto"]?.ktpBase64}
                                disabled={!this.props.state.isEditable}
                                value={this.props.data.dataPhoto?.ktpBase64}
                                onChange={(value, name) => this.handleChangeFile(name, value)}
                            />
                        </FlexView>
                    </div>
                    <div id="grid-2">
                        <FlexView column style={{height: "45%"}}>
                            <SimpleCamera
                                id="input_upload_foto_kk"
                                name="kartuKeluargaBase64"
                                label="2. Foto Kartu Keluarga"
                                enableUpload
                                disabled={!this.props.state.isEditable}
                                value={this.props.data.dataPhoto?.kartuKeluargaBase64}
                                onChange={(value, name) => this.handleChangeFile(name, value)}
                            />
                        </FlexView>
                    </div>
                </div>
            </>
        )
    }
}

export default TabFoto;